import { Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from '@/components/ui/use-toast';
import { LANGUAGES, setLanguage, type LanguageCode } from '@/i18n';

/**
 * Only the ~120 keys ported from the legacy app's i18n.js are translated —
 * newer screens (superadmin, substitutes, exports, GST/dead-stock reports)
 * still render in English regardless of the choice made here.
 */
export function LanguageCard() {
  const { t, i18n } = useTranslation();
  const current = i18n.language as LanguageCode;

  function handleSelect(code: LanguageCode) {
    setLanguage(code);
    toast({ title: t('settingsLangSaved'), variant: 'success' });
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Languages className="h-4 w-4" /> {t('settingsLanguage')}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="mb-3 text-sm text-muted-foreground">{t('settingsSelectLang')}</p>
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
          {(Object.entries(LANGUAGES) as [LanguageCode, (typeof LANGUAGES)[LanguageCode]][]).map(([code, meta]) => (
            <button
              key={code}
              type="button"
              onClick={() => handleSelect(code)}
              className={`flex items-center gap-2 rounded-md border px-3 py-2 text-sm transition-colors ${
                current === code
                  ? 'border-primary bg-primary/10 font-medium text-primary'
                  : 'border-border hover:bg-muted'
              }`}
            >
              <span>{meta.flag}</span>
              <span>{meta.native}</span>
            </button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}